/* MPACK · behaviour: scroll reveal, count-up, filtrai, klipai, header.
   Vanilla, no build step. Anime.js is only pulled in where a tween genuinely
   needs JS (count-up); the hero load sequence is CSS keyframes so it can never
   be left invisible by a failed CDN import.

   2026-09-15: hero būsenų mašina (chip'ai, vėduoklė, kabliukas su kaina)
   išimta kartu su produktais ant hero. Kodas gyvas git'e ties commit'u prieš
   „hero: palikti tik video ir MPACK kaukę". */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Reveal: headings and first-row cards only, 80ms stagger via [data-d].
     ---------------------------------------------------------------------- */
  function reveal() {
    var items = document.querySelectorAll('.mpack-rv:not(.is-in)');
    if (!items.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      /* Positive bottom margin, not negative: the root's edge grows
         downward, so a section is marked "in" while it is still ~15% of
         the viewport below the fold. That gives the 500ms transition
         (--mpack-rv-load) room to finish before the reader actually
         scrolls it into view, instead of firing only once it is already
         deep inside the viewport. threshold: 0 fires on first pixel. */
      { rootMargin: '0px 0px 15% 0px', threshold: 0 }
    );

    items.forEach(function (el) {
      io.observe(el);
    });
  }


  /* ------------------------------------------------------------------------
     Count-up (brief §11): stats numbers tick from 0 when the band scrolls in,
     once, never again. Anime.js v4 does the tween when the CDN answers; if it
     does not, the rAF fallback below runs the same curve. Either way the final
     number is already in the DOM from Liquid, so a total JS failure leaves the
     correct value on screen.

     Values that are not purely numeric ("Be virimo") are left untouched: the
     merchant is allowed to type words into the same field.
     ---------------------------------------------------------------------- */
  var ANIME_URL = 'https://cdn.jsdelivr.net/npm/animejs@4/+esm';
  var animePromise = null;

  function loadAnime() {
    if (!animePromise) animePromise = import(ANIME_URL);
    return animePromise;
  }

  /* Tukstanciu skirtukas priklauso nuo kalbos: lietuviskai tarpas, angliskai
     kablelis. Imamas tas pats, kuris jau yra vertime, tad skaiciavimas nekeicia
     to, ka mato lankytojas. */
  function groupDigits(n, sep) {
    var s = String(n);
    if (!sep || s.length < 4) return s;
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function runCount(el) {
    var raw = el.textContent.trim();
    var digits = raw.replace(/[\s\u00a0,]/g, '');
    el.setAttribute('data-counted', '');
    if (!/^\d+$/.test(digits)) return;

    var target = parseInt(digits, 10);
    var sep = '';
    if (/,\d{3}/.test(raw)) sep = ',';
    else if (/[\s\u00a0]/.test(raw)) sep = '\u00a0';
    if (target < 2) return;

    /* Measured with the final text still in place, so the box can only be too
       wide, never too narrow. */
    el.style.minWidth = el.offsetWidth + 'px';

    function paint(v) {
      el.textContent = groupDigits(Math.round(v), sep);
    }

    paint(0);

    var box = { n: 0 };

    loadAnime()
      .then(function (mod) {
        mod.animate(box, {
          n: target,
          duration: 1400,
          ease: 'out(3)',
          onUpdate: function () {
            paint(box.n);
          },
          onComplete: function () {
            paint(target);
          }
        });
      })
      .catch(function () {
        var start = performance.now();
        (function step(now) {
          var t = Math.min((now - start) / 1400, 1);
          paint(target * (1 - Math.pow(1 - t, 3)));
          if (t < 1) requestAnimationFrame(step);
        })(start);
      });
  }

  function counters() {
    var els = document.querySelectorAll('[data-mpack-count]:not([data-counted])');
    if (!els.length) return;

    var still = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (still.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.setAttribute('data-counted', '');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          runCount(entry.target);
        });
      },
      { threshold: 0.6 }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------------------
     Filter chips over the meals grid (brief §4 #4).

     One-of-many filter over a single grid, so it is a tab set: the chips carry
     role="tab" with a roving tabindex and the grid is the panel.

     Matching is done on the card's data-collections first, falling back to
     data-tags. 2026-09-19: „Klasika" was pinned to the tag `mesiskas` while
     Admin puts the BBQ pasta in the Klasika collection without that tag, so the
     chip hid a product the merchant had explicitly filed under it. Collection
     membership is the thing the merchant actually curates; the tag stays as the
     fallback for chips that have no collection set.
     ---------------------------------------------------------------------- */
  function initFilter(grid) {
    var panelId = grid.id;
    var chips = Array.prototype.slice.call(
      document.querySelectorAll('[aria-controls="' + panelId + '"]')
    );
    if (!chips.length) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.mpack-card'));
    var root = grid.closest('.mpack-meals') || document;
    var empty = root.querySelector('[data-mpack-filter-empty]');
    var status = root.querySelector('[data-mpack-filter-status]');
    var countLabel = grid.getAttribute('data-count-label') || '#';

    function apply(chip) {
      var tag = chip ? chip.getAttribute('data-filter-tag') : '';
      var handle = chip ? chip.getAttribute('data-filter-collection') : '';
      var shown = 0;
      cards.forEach(function (card) {
        var hit;
        if (handle) {
          var inCollections = (card.getAttribute('data-collections') || '').split(',');
          hit = inCollections.indexOf(handle) !== -1;
        } else {
          var tags = (card.getAttribute('data-tags') || '').split(',');
          hit = !tag || tags.indexOf(tag) !== -1;
        }
        if (hit) {
          card.style.setProperty('--filter-index', shown);
          shown += 1;
        }
        /* Removing the attribute first restarts the entry animation; without
           it a card that was already visible would not replay. */
        card.removeAttribute('data-filtered');
        void card.offsetWidth;
        card.setAttribute('data-filtered', hit ? 'in' : 'out');
      });

      if (empty) empty.hidden = shown > 0;
      if (status) status.textContent = countLabel.replace('#', shown);
    }

    function select(chip, focus) {
      chips.forEach(function (c) {
        var on = c === chip;
        c.setAttribute('aria-selected', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
      });
      if (focus) chip.focus();
      apply(chip);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        select(chip, false);
      });
    });

    chips[0].parentNode.addEventListener('keydown', function (e) {
      var i = chips.indexOf(document.activeElement);
      if (i < 0) return;
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = chips[(i + 1) % chips.length];
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = chips[(i - 1 + chips.length) % chips.length];
      if (e.key === 'Home') next = chips[0];
      if (e.key === 'End') next = chips[chips.length - 1];
      if (!next) return;
      e.preventDefault();
      select(next, true);
    });
  }

  function filters() {
    document.querySelectorAll('[data-mpack-filter]').forEach(initFilter);
  }

  /* ------------------------------------------------------------------------
     Video (brief §4 #9): an external embed is not requested until the visitor
     presses play, so YouTube/Vimeo set no cookies on a visitor who never
     watches. Shopify-hosted video needs none of this and is handled by Liquid.
     ---------------------------------------------------------------------- */
  function initVideo(box) {
    var button = box.querySelector('[data-mpack-video-play]');
    var embed = box.getAttribute('data-embed');
    if (!button || !embed) return;

    button.addEventListener('click', function () {
      var frame = document.createElement('iframe');
      frame.src = embed;
      frame.title = box.getAttribute('data-title') || '';
      frame.allow = 'autoplay; fullscreen; picture-in-picture';
      frame.setAttribute('allowfullscreen', '');
      frame.loading = 'lazy';
      box.appendChild(frame);
      button.hidden = true;
      var poster = box.querySelector('.mpack-video__poster');
      if (poster) poster.hidden = true;
      var duration = box.querySelector('[data-mpack-video-duration]');
      if (duration) duration.hidden = true;
    });
  }

  /* Savas ciklinis klipas. Trys taisyklės, visos dėl to paties: klipas yra
     fonas, ne medija. Groja tik ekrane (kitaip vaizdo plokštė suka kadrus
     tuščiai), niekada su garsu ir niekada, kai prašoma mažiau judesio: tada
     lieka pirmas kadras, t. y. plakatas. */
  function initLoop(box) {
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    var video = box.querySelector('video');

    if (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      var play = function () {
        if (calm.matches) return;
        var started = video.play();
        /* Naršyklė gali atmesti net nutildytą paleidimą (pvz., taupymo režimu).
           Tai ne klaida: lieka plakatas. */
        if (started && started.catch) started.catch(function () {});
      };
      var pause = function () {
        if (!video.paused) video.pause();
      };

      if (!('IntersectionObserver' in window)) {
        play();
      } else {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) play();
              else pause();
            });
          },
          { threshold: 0.25 }
        ).observe(box);
      }

      var onCalmVideo = function () {
        if (calm.matches) {
          pause();
          video.currentTime = 0;
        }
      };
      if (calm.addEventListener) calm.addEventListener('change', onCalmVideo);
      else if (calm.addListener) calm.addListener(onCalmVideo);
    }

  }

  function videos() {
    document.querySelectorAll('[data-mpack-video]').forEach(initVideo);
    document.querySelectorAll('[data-mpack-loop]').forEach(initLoop);
  }

  /* ------------------------------------------------------------------------
     Sticky buy bar on the product page. It appears only once the real add to
     cart button has scrolled off the top, so it never duplicates a control the
     buyer can already see. IntersectionObserver, not a scroll listener: the
     browser does the work off the main thread.
     ---------------------------------------------------------------------- */
  function stickyCta() {
    var bar = document.querySelector('mpack-sticky-cta');
    if (!bar) return;

    var anchor = document.querySelector('.product-form__buttons, add-to-cart-component, .buy-buttons-block');
    if (!anchor) return;

    if (!('IntersectionObserver' in window)) {
      bar.hidden = false;
      return;
    }

    /* Same pair as assets/sticky-add-to-cart.js (Vessel's own bar): the buy
       buttons decide whether the bar is due at all, the footer decides
       whether it must step aside. Without the second observer the bar stays
       fixed for the rest of the scroll and sits on top of whatever ends up
       last on the page — here, the safety-instruction button in
       mpack-steps. */
    var passedAnchor = false;
    var nearFooter = false;
    var render = function () {
      var show = passedAnchor && !nearFooter;
      bar.hidden = !show;
      bar.classList.toggle('is-in', show);
    };

    /* No rootMargin here on purpose: a negative bottom margin large enough to
       reach the anchor (e.g. -100%) collapses the observed root to zero
       height, so it can never intersect anything and the callback only ever
       fires once, at observe time, with isIntersecting permanently false —
       passedAnchor then never leaves its initial value no matter how far the
       page scrolls. Same default-root pattern as Vessel's own buy-buttons
       observer in sticky-add-to-cart.js: a non-intersecting entry is either
       fully above the viewport (bottom < 0, scrolled past) or fully below it
       (top > 0, not reached yet) — the two cases threshold-crossing already
       tells apart without needing a shrunk root. */
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            passedAnchor = false;
          } else if (entry.boundingClientRect.bottom < 0) {
            passedAnchor = true;
          } else if (entry.boundingClientRect.top > 0) {
            passedAnchor = false;
          }
          render();
        });
      }
    ).observe(anchor);

    var footer = document.querySelector('footer, [class*="footer-group"]');
    if (footer) {
      /* Positive bottom margin, not top: it grows the root past the actual
         viewport's bottom edge, so the footer counts as "near" while it is
         still up to 200px below the fold, not only once it has already
         scrolled into view. The safety button in mpack-steps sits ~56px
         above the footer, closer than the bar's own height, so a margin
         that only reacted once the footer was already visible would still
         let the bar cover the button for part of the scroll. */
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            nearFooter = entry.isIntersecting;
            render();
          });
        },
        { rootMargin: '0px 0px 200px 0px' }
      ).observe(footer);
    }
  }

  /* ------------------------------------------------------------------------
     Add to cart, the answer (brief §11). Vessel already opens the drawer and
     re-renders the counter; what it never does is answer the control that was
     pressed, so the buyer on a long collection page has to look elsewhere to
     learn anything happened.

     The state waits for shopify:cart:lines-update rather than the click, so
     „Įdėta" is only ever said about a line the cart really took. Its label
     rides in on data-mpack-added (snippets/add-to-cart-button.liquid), which
     keeps every Lithuanian string in locales/ and none of them here.
     ---------------------------------------------------------------------- */
  var ADDED_MS = 1400;
  var TICK = '<svg class="mpack-added__tick" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<path d="M3.4 8.5 6.5 11.6 12.6 4.9" stroke="currentColor" stroke-width="1.9" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var pressedButton = null;
  var pressedAt = 0;
  var addedButton = null;
  var addedTimer;

  function clearAdded(button) {
    button.classList.remove('mpack-is-added');
    var flag = button.querySelector('.mpack-added');
    if (flag) flag.remove();
  }

  /* Capture phase: Vessel's own click handler may re-render the form, and by
     the time a bubbled listener runs the button can already be detached. */
  function rememberPress(event) {
    var button = event.target.closest && event.target.closest('button[name="add"]');
    if (!button || button.disabled) return;
    pressedButton = button;
    pressedAt = Date.now();
  }

  function answerPress() {
    /* Cart lines also change from the drawer's own quantity steppers and from
       a removed line. Only a press from the last few seconds earns the state,
       so the button never lights up for something the buyer did elsewhere. */
    if (!pressedButton || Date.now() - pressedAt > 4000) return;

    var button = pressedButton;
    pressedButton = null;
    if (!button.isConnected || !button.dataset.mpackAdded) return;

    clearTimeout(addedTimer);
    /* Two adds in a row from different controls: the earlier flag goes now,
       otherwise its timer is cleared with it and it would sit there for good. */
    if (addedButton && addedButton !== button) clearAdded(addedButton);
    clearAdded(button);

    var flag = document.createElement('span');
    flag.className = 'mpack-added';
    /* The live region in the product form announces the add already; a second
       voice reading the same news is noise. */
    flag.setAttribute('aria-hidden', 'true');
    flag.innerHTML = TICK + '<span>' + button.dataset.mpackAdded + '</span>';
    button.appendChild(flag);
    button.classList.add('mpack-is-added');
    addedButton = button;

    addedTimer = setTimeout(function () {
      clearAdded(button);
      if (addedButton === button) addedButton = null;
    }, ADDED_MS);
  }

  function cartFeedback() {
    /* init() runs again on every shopify:section:load, the listeners live on
       document, so they are bound once and never per section. */
    if (document.documentElement.hasAttribute('data-mpack-cart-bound')) return;
    document.documentElement.setAttribute('data-mpack-cart-bound', '');

    document.addEventListener('click', rememberPress, true);
    document.addEventListener('shopify:cart:lines-update', answerPress);
  }

  /* ------------------------------------------------------------------
     --mpack-header-h · kiek vertikalios vietos virš pirmos sekcijos
     užima fiksuota viršutinė dalis: announcement juosta + plaukiojantis
     header kartu su savo viršutiniu tarpu.

     Vessel savo --header-height turi, bet jis parašomas prieš layout'ą ir
     pirmą kartą buvo 102px, kai tikrasis aukštis 92px, todėl hero po juo
     lįsdavo. Šitas kintamasis yra vienintelis hero tarpo šaltinis.

     2026-09-19 (2 etapas): pati geometrija iš čia išsikėlė į
     `snippets/mpack-measure-header.liquid` ir kviečiama per
     `window.mpackHeaderFlowHeight`. Priežastis ta, kad ši byla kraunama su
     `defer`, t. y. po pirmo piešimo: kol ji nesuveikdavo, hero rėmėsi CSS
     atsarginiu skaičiumi (146px), o tikroji reikšmė yra 140px, tad turinys
     pašokdavo 6 px. Snippet'as matuoja iškart už header-group, dar iki pirmo
     kadro; čia lieka tik perskaičiavimas, kai kas nors pasikeičia. Dvi tos
     pačios formulės kopijos neišvengiamai išsiskirtų, tad kopijos nėra.
     ------------------------------------------------------------------ */
  var headerObserver;

  function scrolledBy() {
    var wrapper = document.querySelector('.page-wrapper');
    return Math.max(
      window.scrollY || 0,
      document.documentElement.scrollTop || 0,
      wrapper ? wrapper.scrollTop : 0
    );
  }

  function measureHeader() {
    var header = document.getElementById('header-component');
    if (!header) return;
    /* Tik puslapio viršuje. Kintamasis aprašo, kiek vietos virš pirmos
       sekcijos užima juosta su header'iu, kai dar nieko neatscrollinta, ir
       hero tuo remiasi. Scrollinant announcement juosta susitraukia, tad
       matuojant tada hero padding'as susitrauktų kartu, o puslapio aukštis
       šokinėtų per tuos pačius ~28 px vidury scroll'o. */
    if (scrolledBy() > 8) return;
    /* And never in the collapsed state. The bar reserves its expanded height in
       CSS now, so this should be unreachable, but the whole point of this
       variable is that the hero reads one number that scrolling cannot touch. */
    var ann = document.querySelector('.mpack-ann');
    if (ann && ann.dataset.collapsed === 'true') return;
    /* Formulė gyvena snippet'e. Jo nesant matavimo nedarome iš viso: geriau
       CSS atsarginis skaičius, nei antras, tyliai nutolęs to paties dalyko
       apskaičiavimas. */
    if (!window.mpackHeaderFlowHeight) return;
    var height = window.mpackHeaderFlowHeight();
    if (!height) return;
    /* Antra apsauga po to paties bug'o: viršutinė juosta niekada neužima nė
       pusės ekrano. Nesveiką matavimą geriau ignoruoti ir palikti ankstesnę
       reikšmę, nei perrašyti juo hero. */
    if (height > window.innerHeight * 0.5) return;
    document.documentElement.style.setProperty('--mpack-header-h', Math.round(height) + 'px');
  }

  function headerHeight() {
    measureHeader();
    var header = document.getElementById('header-component');
    if (!header || !window.ResizeObserver) return;
    if (headerObserver) headerObserver.disconnect();
    /* Meniu perlūžta į dvi eilutes, o šriftai atkeliauja po pirmo piešimo. */
    /* The header only. The announcement bar used to be observed here too, and
       that closed the circle: the bar collapses on scroll, the observer fired,
       --mpack-header-h moved, the hero padding moved with it and the document
       changed height mid-scroll. The bar is not observed at all now, and the
       header itself has no collapsing state, so nothing this observer sees can
       have been caused by this observer. */
    headerObserver = new ResizeObserver(measureHeader);
    headerObserver.observe(header);
  }

  /* ------------------------------------------------------------------
     data-mpack-ground="light" · po juosta atsidūrė šviesi sekcija.

     Stiklas rgba(21,16,13,.55) gerai laikosi ant tamsaus fono, bet virš
     šviesios „inset" lentelės ar oranžinės juostos jis nublanksta ir
     kreminės meniu raidės lieka beveik be kontrasto. Ten fonas nueina
     dviem žingsniais tamsyn, blur'as nesikeičia, tad juosta ir toliau
     lieka stiklas, o ne antra vientisa juosta.

     Klausomasi per document capture fazę: puslapį scrollina .page-wrapper,
     o elementų scroll įvykiai nekyla iki window, tad įprastas
     window.addEventListener('scroll') čia nieko negautų.
     ------------------------------------------------------------------ */
  var lightGrounds = [];
  var groundTick = false;
  var groundObserver = null;

  function readGround() {
    groundTick = false;
    var header = document.getElementById('header-component');
    if (!header) return;
    var bar = header.getBoundingClientRect();
    var top = bar.top;
    var bottom = bar.bottom;

    /* Atsidaręs mega meniu skydelis dažo tas pačias stiklo spalvas, tik nusidriekia
       dar keliais šimtais pikselių žemyn. Jei tikrintume vien juostą, skydelis
       nusėstų ant šviesios lentelės su .55 užpildu ir liktų permatomas. */
    var openSubmenu = header.querySelector('.menu-list__submenu:not([inert])');
    if (openSubmenu) {
      var panel = openSubmenu.getBoundingClientRect();
      if (panel.bottom > bottom) bottom = panel.bottom;
    }

    var over = false;
    for (var i = 0; i < lightGrounds.length; i++) {
      var s = lightGrounds[i].getBoundingClientRect();
      if (s.top < bottom && s.bottom > top) {
        over = true;
        break;
      }
    }
    if (over) header.setAttribute('data-mpack-ground', 'light');
    else header.removeAttribute('data-mpack-ground');
  }

  function queueGround() {
    if (groundTick) return;
    groundTick = true;
    requestAnimationFrame(readGround);
  }

  function headerGround() {
    lightGrounds = Array.prototype.slice.call(
      document.querySelectorAll('.mpack-scheme--inset, .mpack-scheme--accent')
    );
    document.removeEventListener('scroll', queueGround, true);
    if (!lightGrounds.length) return;
    document.addEventListener('scroll', queueGround, true);

    /* Meniu atsidaro ir užsidaro be jokio scroll'o, o Vessel'io header-menu.js
       tam neturi viešo įvykio. Užtat jis kiekvienam skydeliui perjungia `inert`,
       ir to visiškai pakanka kaip signalui. */
    var header = document.getElementById('header-component');
    if (header && window.MutationObserver) {
      if (groundObserver) groundObserver.disconnect();
      groundObserver = new MutationObserver(queueGround);
      groundObserver.observe(header, {
        subtree: true,
        attributes: true,
        attributeFilter: ['inert'],
      });
    }

    readGround();
  }

  function init() {
    headerHeight();
    headerGround();
    reveal();
    counters();
    filters();
    videos();
    stickyCta();
    cartFeedback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Webfonts land after first paint: measure again once they are ready. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measureHeader);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      measureHeader();
      readGround();
    }, 120);
  });

  /* Theme editor: sections are re-rendered without a page load. */
  document.addEventListener('shopify:section:load', init);
})();
